module.exports = __webpack_public_path__ + "img/DealerIcons-T2-Off.b1db636.jpg";